import { first, OperatorFunction } from "rxjs";

//first errors when it's source completes without emiting anything and no default is provided. Its more likely you want take and its derivitives. Think carefully when using
export function firstSet<T>(defaultValue?:T):OperatorFunction<T,T>{
	return first(v=>!!v,defaultValue);
}
